import { Breadcrumbs, CreateButton, DynamicEntityIndex, FlashMessage, GlobalLoader, InputField, Modal, ModalAlert } from '@reactiveonline/reactive_admin_shared-packages'
import { emailValidation } from '@reactiveonline/reactive_admin_shared-packages/utils'
import React, { useRef, useState } from 'react'
import GlobalImports from '../shared/GlobalImports'

export default function DirectorsIndex({
  appProps, administrators, breadcrumbs, deleteSuperadminPath, entityPath, icon, initialCount, initialTotalPages, inviteSuperadminPath, listColumns, reinvitePath, selectedColumns
}) {
  const [admins, setAdmins] = useState(administrators)
  const [totalCount, setTotalCount] = useState(initialCount)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [adminToBeDeleted, setAdminToBeDeleted] = useState(null)
  const [newAdministratorEmail, setNewAdministratorEmail] = useState('')
  const [newAdministratorName, setNewAdministratorName] = useState('')
  const [loading, setLoading] = useState(false)

  const flashMessageRef = useRef(null)

  const closeModal = () => {
    setNewAdministratorEmail('')
    setNewAdministratorName('')
    setShowCreateModal(false)
  }

  const handleDeleteSuperadmin = () => {
    const fd = new FormData()

    fd.append('administrator_api_uid', adminToBeDeleted.apiUid)

    setAdminToBeDeleted(null)
    setLoading(true)

    Rails.ajax({
      type: 'DELETE',
      url: deleteSuperadminPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        setTotalCount(res.administratorsCount)
        setAdmins(res.administrators)
        flashMessageRef.current.show(res.message)
      }
    })
  }

  const handleReinvite = administrator => {
    const fd = new FormData()

    fd.append('administrator_api_uid', administrator.apiUid)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: reinvitePath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  const inviteSuperadmin = () => {
    const fd = new FormData()
    fd.append('admin_email', newAdministratorEmail)
    fd.append('admin_name', newAdministratorName)

    closeModal()
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: inviteSuperadminPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        setTotalCount(res.administratorsCount)
        setAdmins(res.administrators)
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
        setLoading(false)
      }
    })
  }

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map((column, index) => {
          if (column.label === 'email') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href='#'>
                  { item[column.label] }
                </a>
              </div>
            )
          } else {
            return (
              <div key={ column.label } className='item flex-1 flex-box items-center content-space-between'>
                { item[column.label] || '-' }

                { index === columns.length - 1 &&
                  <div className='flex-box items-center content-space-between' style={{ gap: '20px' }}>
                    { item.canReinvite &&
                      <i
                        className='fa-light fa-envelope'
                        style={{ cursor: 'pointer' }}
                        onClick={ _e => handleReinvite(item) }
                      />
                    }
                    { item.canDelete &&
                      <i
                        className='fa-light fa-trash'
                        style={{ cursor: 'pointer' }}
                        onClick={ _e => setAdminToBeDeleted(item) }
                      />
                    }
                  </div>
                }
              </div>
            )
          }
        })}
      </>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div>
          <div className='page-header'>
            <i className={ `fa-light ${ icon }` }/>
            <h1 className='page-header-title'>
              { Partners.translations.administrator.plural }
              <span className='m-l-10'>({ totalCount })</span>
            </h1>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>

        <CreateButton
          onClickCreate={ () => setShowCreateModal(true) }
          createTitle={ Partners.translations.administrator.invite_superadmin }
        />
      </div>

      <DynamicEntityIndex
        initialItems={ admins }
        initialTotalPages={ initialTotalPages }
        disableDelete={ true }
        disableCustomization={ true }
        disableSearch={ true }
        entity={ 'administrators' }
        tableHeadings={ selectedColumns }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ icon }
        listColumns={ listColumns }
        columnTranslations={ Partners.translations.columns }
      />

      { showCreateModal &&
        <Modal
          visible
          mode='medium'
          closeModal={ closeModal }
          action={ inviteSuperadmin }
          actionText={ ReactiveCore.translations.confirm }
          disableAction={ !emailValidation(newAdministratorEmail) }
        >
          <div className='flex-box flex-column flex-1'>
            <div className='bold' style={{ fontSize: 25 }}>
              { Partners.translations.invite_administrator }
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.user.name }
              >
                <input
                  type='text'
                  value={ newAdministratorName }
                  onChange={ e => setNewAdministratorName(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.administrator.attributes.email }
              >
                <input
                  type='text'
                  value={ newAdministratorEmail }
                  onChange={ e => setNewAdministratorEmail(e.target.value) }
                />
              </InputField>
            </div>

          </div>
        </Modal>
      }

      { !!adminToBeDeleted &&
        <ModalAlert
          alert={ Partners.translations.destroy_administrator_alert }
          onSelect={ _e => handleDeleteSuperadmin() }
          onClose={ () => setAdminToBeDeleted(null) }
        />
      }

      { loading && <GlobalLoader fullPage /> }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
